import { Tiles, LinkTiles, GettingStartedTile } from "../tile/tile";
import { useMemo } from "react";

export function ThemedTiles(props) {
    const { Visible, Theme, OnClick, Tiles: tiles, HideDescription } = props;

    const tilesToRender = useMemo(() => HideDescription ? tiles.map(tile => ({ ...tile, Description: null })) : tiles, [tiles, HideDescription]);

    if (!Visible)
        return null;

    if (Theme === "web") {
        return (
            <Tiles
                Theme={Theme}
                ColumnGap={8}
                RowGap={8}
                ColumnNumber={3}
                Tiles={tilesToRender}
                Tile={(tile) => <GettingStartedTile Tile={tile} Dark OnClick={() => OnClick(tile)} />} />
        );
    }

    return (
        <LinkTiles
            Theme={Theme}
            Tiles={tilesToRender}
            OnClick={(tile) => OnClick(tile)} />
    );
}